'use strict';

export default class FreightTime {
  constructor($http, $q) {
    'ngInject';
    this._$http = $http;
    this._$q = $q;
  }

  query() {
    // Create the $http object for this request
    let request = {
      url: '/api/freightTime',
      method: 'GET',
    };

    return this._$http(request).then(res => res.data);
  }

  save(times) {
    let request = {};
    request.url = '/api/freightTime';
    request.method = 'POST';

    request.data = times;

    return this._$http(request).then(res => res.data);
  }

}



// WEBPACK FOOTER //
// ./client/components/services/freightTime.service.js